import { Cart, Person, Product } from '../entities';

export enum CartEventType {
  // non-meaningful events not afecting the price
  personNameUpdated = 0,
  personSelected = 10,
  discountsUpdated = 20,
  insuranceUpdated = 30,
  registerDataUpdated = 40,
  cartInitialisedByIDB = 100,
  // meaningful events affecting the price
  cartInitialised = 110,
  dateRangeUpdated = 120,
  personAdded = 130,
  personRemoved = 140,
  personAgeUpdated = 150,
  productUpdated = 160,
  productRemoved = 170,
  promocodeUpdated = 180,
  couponcodeUpdated = 190
}

export enum InsuranceType {
  flexi = 1,
  insurance = 2,
  insurancePlus = 3
}

export interface BaseCartEvent {
  eventType:
    | CartEventType.personNameUpdated
    | CartEventType.personSelected
    | CartEventType.discountsUpdated
    | CartEventType.insuranceUpdated
    | CartEventType.cartInitialisedByIDB
    | CartEventType.cartInitialised
    | CartEventType.dateRangeUpdated
    | CartEventType.registerDataUpdated
    | CartEventType.personAdded
    | CartEventType.personRemoved
    | CartEventType.personAgeUpdated
    | CartEventType.promocodeUpdated
    | CartEventType.couponcodeUpdated;
  cart: Cart;
}

export interface CartEventProductRemoval {
  eventType: CartEventType.productRemoved;
  cart: Cart;
  product: Product;
  person: Person;
}

export interface CartEventProductUpdated {
  eventType: CartEventType.productUpdated;
  cart: Cart;
  product: Product;
  person: Person;
  // if a product was "replaced", we have the previous version here. Used on analytics
  replacedProduct?: Product;
}

export class CartPersonInterface {
  products: { definitionId: number; addons?: number[] }[]; // {definitionId:12 (SNOWBOARD), addons: [1,2,3] (helmet,boots,insurance)}
  age: number;
  weight?: string;
  height?: string;
  shoe_size?: string;
  skill?: string;
}
export class CartInterface {
  persons: CartPersonInterface[];
  startDate?: string;
  endDate?: string;
  promotionCode?: string;
  couponCode?: string;
  insurances?: InsuranceType[];
}

export interface RegisterData {
  firstname: string;
  surname: string;
  customerCountry: string;
  phone: string;
  accommodation_name: string;
  accommodation_address: string;
  email: string;
}
